<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("central dispatch tracker module settings") }}
      </h1>
    </div>

    <div class="box">
      <div class="title is-5">{{}}</div>
      <div class="columns mt-5">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('analyst signer')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/signer/catalog"
              name_field="name"
              value_field="signer_id"
              @selected="analyst_signer_changed"
              ref="analyst_signer_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('operation manager signer')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/signer/catalog"
              name_field="name"
              value_field="signer_id"
              @selected="operation_manager_signer_changed"
              ref="operation_manager_signer_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("rci threshold") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.rci_threshold"
                placeholder="0.6"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default nationality") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.default_nationality"
                placeholder="GUATEMALTECO(A)"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("default purpose") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.default_purpose"
                placeholder="Capital de trabajo"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("sirc file name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.sirc_file_name"
                placeholder="SIRC.pdf"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("months term for credit card") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.months_term_for_credit_card"
                placeholder="60"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  api_host,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "DictamenSettings",
  components: { GenericDropdown, GenericUploader },
  data() {
    return {
      meta: {},
      api_host,
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {})
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    analyst_signer_changed(signer) {
      let v = this;
      if (signer) {
        v.meta.analyst_signer_id = signer.signer_id;
      }
    },
    operation_manager_signer_changed(signer) {
      let v = this;
      if (signer) {
        v.meta.operation_manager_signer_id = signer.signer_id;
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;

        if (v.meta.analyst_signer_id)
          v.$refs.analyst_signer_dropdown.set_value(v.meta.analyst_signer_id);

        if (v.meta.operation_manager_signer_id)
          v.$refs.operation_manager_signer_dropdown.set_value(
            v.meta.operation_manager_signer_id
          );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
